import SocialFormPanel from './SocialFormPanel';

export default SocialFormPanel;


// WEBPACK FOOTER //
// ./src/components/forms/SocialFormPanel/index.js